import { ShortcutBarItem } from "./interface";
import { FeatureAttribution } from "../../stories/shared/interfaces/featureAttribution";

export const SHORTCUTS_LINKS_TRACKING_DATA: FeatureAttribution = {
    name: "navigation",
    instance: "shortcuts-bar",
};
export const SHORTCUTS_MODAL_TRACKING_DATA = {
    "data-feature-name": "modal",
    "data-feature-instance": "shortcuts-bar",
};

export const ALL_SHORTCUTS_BAR_LINKS: ShortcutBarItem[] = [
    {
        url: "/news/local",
        external: false,
        label: "My Local",
    },
    {
        url: "/sports",
        external: false,
        label: "Sports",
    },
    {
        url: "https://www.cbc.ca/listen",
        external: true,
        label: "CBC Listen",
    },
    {
        url: "https://gem.cbc.ca/",
        external: true,
        label: "CBC Gem",
    },
];

export const getDefaultShortcutsBarLinks = (): ShortcutBarItem[] => {
    return ALL_SHORTCUTS_BAR_LINKS.filter((link, i) => {
        return link.label === "My Local" || link.label === "Sports";
    });
};
